import axios from 'axios';

export * from './routes.constants';

// //dev
// export const baseURL = 'https://estateappbackend.herokuapp.com/api/v1';

//new dev
export const baseURL = 'https://zealightestate-app.herokuapp.com/api/v1';

//prod
// export const baseURL = 'https://estateapp-api.herokuapp.com/api/v1';

const axiosInstance = axios.create({
  baseURL,
  // baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json ',
    'Access-Control-Allow-Headers': 'Content-Type',
  },
});

const addTokenToRequest = async (req) => {
  const token = sessionStorage.getItem('11#221#');
  req.headers.Authorization = `Bearer ${token}`;
  return req;
};

axiosInstance.interceptors.request.use(addTokenToRequest);

export default axiosInstance;
